import {
  ArrPeople,
  Measurements,
  Stats,
} from '../../../../store/analytics/analytics.types';

export type RelationsArray = {
  title: string;
  loading: boolean;
  people: ArrPeople | undefined;
}[];

export const createRelationsArray = (
  stats: Stats | null,
  isLoading: boolean
): RelationsArray => [
  {
    title: 'Most active',
    loading: isLoading,
    people: stats?.mostActiveParticipants,
  },
  {
    title: 'most Competent With',
    loading: isLoading,
    people: stats?.mostCompetentVs,
  },
  {
    title: 'Least Competent With',
    loading: isLoading,
    people: stats?.leastCompetentVs,
  },
];

export const createInfoBarsArray = (
  measurements: Measurements | null,
  animationDuration: number,
  isLoading: boolean
) => [
  {
    title: 'empathy',
    min: -1.75,
    max: 1.5,
    current: measurements?.empathy,
    toolTip: `Empathy allows you to walk a mile in your clients' shoes and understand their pain 
        points and motivations. Too much empathy and you will lose your advantage. 
        Too little and you may appear hostile.`,
    animationTime: animationDuration,
    sketWidth: 70,
    isLoading,
  },
  {
    title: 'responsiveness',
    min: -1.3,
    max: 1,
    current: measurements?.responsiveness,
    toolTip: `Your average response time to your clients. This may impact the way 
        you are perceived by them. Too fast may signal neediness, 
        too slow and you may find yourself out of the game.`,
    animationTime: animationDuration,
    sketWidth: 115,
    isLoading,
  },
  {
    title: 'resilience',
    min: 0,
    max: 2,
    current: measurements?.resilience,
    toolTip: `Being resilient pays off. Following suggested moves even 
        when pressured might be hard, yet rewarding. 
        On the other hand, don't let yourself be too rigid.`,
    animationTime: animationDuration,
    sketWidth: 81,
    isLoading,
  },
  {
    title: 'intuition',
    min: 0,
    max: 2,
    current: measurements?.intuition,
    toolTip: `An important trait for any salesperson, this shows you 
        how accurate is your gut feeling. 
        Don't worry if you're not spot on, that's what we're here for`,
    animationTime: animationDuration,
    sketWidth: 72,
    isLoading,
  },
  {
    title: 'subtleness',
    min: 0,
    max: 1,
    current: measurements?.subtleness,
    toolTip: 'Coming soon',
    animationTime: animationDuration,
    sketWidth: 88,
    isLoading,
  },
];
